import { signal } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { DATABASE_NAME } from 'src/app/config/app.config';
import { STORE_DATABASE } from 'src/app/core/enums/storage/store-database.enum';
import { IndexedDBRepository } from 'src/app/shared/interface/indexed-db-storage.model';
import { TRACKER_TYPE } from '../enums/tracker.enum';
import { ITrackingRecord } from './tracking-record.interface';

export abstract class Tracker<T> extends IndexedDBRepository<ITrackingRecord<T>> {
  currentTrack = signal<ITrackingRecord<T> | null>(null);

  addTrack(
    trackId: string,
    type: TRACKER_TYPE,
    body: T
  ): Observable<ITrackingRecord<T> | null> {
    const newTrack = {
      body,
      type: type,
    };

    this.currentTrack.set(newTrack);

    return this.setItem(trackId, newTrack);
  }

  getTrack(trackId: string): Observable<ITrackingRecord<T> | null> {
    if (this.currentTrack()) {
      return of(this.currentTrack());
    }

    return this.getItem(trackId).pipe(
      tap((track) => this.currentTrack.set(track))
    );
  }

  removeTrack(trackId: string): Observable<void> {
    this.currentTrack.set(null);

    return this.removeItem(trackId);
  }
}

export class TrackerImpl<T> extends Tracker<T> {
  protected override dbName = DATABASE_NAME;
  protected override instanceName = STORE_DATABASE.tracking;
}
